import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { BaseModalComponent } from '../../base-modal/base-modal.component';
import { UsbBaseModalComponent } from '../../usb-base-modal/usb-base-modal.component';

@Component({
  selector: 'usb-choose-agency-modal',
  templateUrl: './choose-agency-modal.component.html',
  styleUrls: ['./choose-agency-modal.component.scss']
})
export class ChooseAgencyModalComponent extends BaseModalComponent implements AfterViewInit {
  public icon: string = '';
  public iconClass: string = '';
  public iconColor: string = '';
  public titleReverse: boolean = false;

  @ViewChild(UsbBaseModalComponent) usbBaseModal: UsbBaseModalComponent;

  constructor(public bsModalRef: BsModalRef) {
    super();
  }

  ngAfterViewInit(): void {
    // Forward events from UsbBaseModalComponent to this component's confirmResult
    if (this.usbBaseModal) {
      this.usbBaseModal.confirmResult.subscribe((result: boolean) => {
        this.confirmResult.next(result);
      });
    }
  }

  protected onInit(): void {
    // Choose-agency-specific initialization if needed
  }
}